import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { IktatgatoService } from '../iktatgato.service';
import { DataService } from '../../data.service';

/** Egy ügyirat teljes képe: iratok (alszámok), állapot, eseménynapló. */
@Component({
  selector: 'app-ikt-ugyirat',
  templateUrl: './ugyirat.component.html',
  styleUrls: ['../iktatgato-layout/iktatgato-layout.component.scss'],
})
export class IktUgyiratComponent implements OnInit {
  id = '';
  ugyirat: any = null;
  iratok: any[] = [];
  esemenyek: any[] = [];
  hiba = '';
  szerkesztes: any = {};

  constructor(private ikt: IktatgatoService, private data: DataService,
              private route: ActivatedRoute, private router: Router) {}

  async ngOnInit() {
    this.id = this.route.snapshot.paramMap.get('id') || '';
    await this.betolt();
  }

  async betolt() {
    try {
      const r = await this.ikt.ugyirat(this.id);
      this.ugyirat = r.ugyirat;
      this.iratok = r.iratok || [];
      this.esemenyek = r.esemenyek || [];
      this.szerkesztes = {
        ugyintezo: this.ugyirat.ugyintezo || '',
        hatarido: this.ugyirat.hatarido || '',
      };
    } catch (e: any) {
      this.hiba = e?.error?.error || 'Az ügyirat nem tölthető be.';
    }
  }

  async ment(adat: any, uzenet: string) {
    try {
      await this.ikt.ugyiratModosit(this.id, adat);
      this.data.sendToast(uzenet);
      await this.betolt();
    } catch (e: any) {
      this.data.sendToast(e?.error?.error || 'A mentés nem sikerült.', 'error');
    }
  }

  szignal() { this.ment({ ugyintezo: this.szerkesztes.ugyintezo, hatarido: this.szerkesztes.hatarido }, 'Szignálva.'); }
  elintez() { this.ment({ allapot: 'elintezve' }, 'Elintézve.'); }
  irattaraz() { this.ment({ allapot: 'irattarban' }, 'Irattárba helyezve.'); }

  async ervenytelenit(tipus: 'ugyirat' | 'irat', id: string) {
    const indok = window.prompt('Az érvénytelenítés indoka (kötelező, naplózódik):') || '';
    if (!indok.trim()) return;
    try {
      await this.ikt.ervenytelenit(tipus, id, indok.trim());
      this.data.sendToast('Érvénytelenítve. Az iktatószám megmarad, nem adható ki újra.');
      await this.betolt();
    } catch (e: any) {
      this.data.sendToast(e?.error?.error || 'Az érvénytelenítés nem sikerült.', 'error');
    }
  }

  ujAlszam() {
    this.router.navigate(['/iktatgato/iktatas'], { queryParams: { ugyirat: this.id } });
  }

  postara(irat: any) {
    this.router.navigate(['/iktatgato/postakonyv'], { queryParams: { irat: irat.id } });
  }

  /** Az alszám részletei: csatolmányok, kiadmányozás, kapcsolatok. */
  iratra(irat: any) { this.router.navigateByUrl('/iktatgato/irat/' + irat.id); }
}
